// extracted by mini-css-extract-plugin
export default {"container":"SafeGuardableTypeformList_container__GRFUQ","padded":"SafeGuardableTypeformList_padded__Z4nrB","status-icon":"SafeGuardableTypeformList_status-icon__Et1yH"};